/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Restore_MsgInputs */



/**
* | output |
* | --- |
* | "Seating and scores are brought back and the round goes live again." |
*
* @param {Rounds_Restore_MsgInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_restore_msg = /** @type {((inputs?: Rounds_Restore_MsgInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Restore_MsgInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La disposition et les scores sont rétablis et la ronde reprend.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La distribución y las puntuaciones se recuperan y la ronda vuelve a estar activa.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("A alocação e as pontuações são recuperadas e a rodada volta a estar ativa.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La disposizione e i punteggi vengono ripristinati e il round torna attivo.")
	return /** @type {LocalizedString} */ ("Seating and scores are brought back and the round goes live again.")
});